// extracted by mini-css-extract-plugin
export default {"card":"Face1_card__Gusta"};